<div class="container-fluid">
  <div class="row">
    <div class="col">
      <label class="fs-16">Password Requirements</label>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <label class="fs-14 fw-400"
        >(Password is correct once all requirements turn green.)</label
      >
    </div>
  </div>

  <div class="row">
    <div class="col">
      <ul>
        <li
          class="fs-14"
          [ngClass]="{
            'error-red': !validatePasswordLength(),
            'success-green': validatePasswordLength()
          }"
        >
          At least EIGHT (8) characters
        </li>
        <li
          class="fs-14"
          [ngClass]="{
            'error-red': !validatePasswordContainsUppercase(),
            'success-green': validatePasswordContainsUppercase()
          }"
        >
          At least ONE (1) uppercase character
        </li>
        <li
          class="fs-14"
          [ngClass]="{
            'error-red': !validatePasswordContainsLowercase(),
            'success-green': validatePasswordContainsLowercase()
          }"
        >
          At least ONE (1) lowercase character
        </li>
        <li
          class="fs-14"
          [ngClass]="{
            'error-red': !validatePasswordContainsNumber(),
            'success-green': validatePasswordContainsNumber()
          }"
        >
          At least ONE (1) number
        </li>
        <li
          class="fs-14"
          [ngClass]="{
            'error-red': !validatePasswordContainsSpecialCharacter(),
            'success-green': validatePasswordContainsSpecialCharacter()
          }"
        >
          At least ONE (1) special character limited to !&#64;#$%^&*
        </li>
        <li
          class="fs-14"
          [ngClass]="{
            'error-red': !validatePasswordsMatch(),
            'success-green': validatePasswordsMatch()
          }"
        >
          BOTH passwords must match.
        </li>
      </ul>
    </div>
  </div>
</div>
